import clsx from "clsx";
import * as React from "react";
import type { FontWeightProps } from "../../helper/FontWeightProps.js";

type DisplayTextElement = React.ElementRef<"p">;
export type DisplayTextSize = "2xl" | "xl" | "lg" | "md";
type DisplayTextTag = "h1" | "h2" | "h3" | "h4";

interface DisplayTextProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    FontWeightProps {
  size?: DisplayTextSize;
  as?: DisplayTextTag;
}

const DisplayText = React.forwardRef<DisplayTextElement, DisplayTextProps>(
  (props, ref) => {
    const {
      className,
      size = "lg",
      as: Tag = "h2",
      fontWeight = "semibold",
      ...rest
    } = props;

    return (
      <Tag
        data-size={size}
        data-font-weight={fontWeight}
        className={clsx("ox-reset ox-ui-Display", className)}
        {...rest}
        ref={ref}
      />
    );
  },
);
DisplayText.displayName = "DisplayText";
export { DisplayText };
export type { DisplayTextProps };
